import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { AppStateContext } from '../../state/AppProvider'

interface MicroLearningGuardProps {
  children: React.ReactNode
}

const MicroLearningGuard: React.FC<MicroLearningGuardProps> = ({ children }) => {
  const appStateContext = useContext(AppStateContext)

  if (!appStateContext) {
    return (
      <Navigate
        to="/"
        replace
      />
    )
  }

  const { state } = appStateContext
  const isMicroLearningEnabled = state.frontendSettings?.micro_learning?.enabled

  if (isMicroLearningEnabled === false || isMicroLearningEnabled === undefined) {
    return (
      <Navigate
        to="/app"
        replace
      />
    )
  }

  return <>{children}</>
}

export default MicroLearningGuard
